import { graphql } from "gatsby";
import { Trans } from "gatsby-plugin-react-i18next";
import React from "react";
import Contacts from "./components/Contacts";
import Layout from "./components/Layout";
import History from "./history";
import Services from "./services";
import AwesomeSlider from "react-awesome-slider";
// import withCaption from "react-awesome-slider/dist/captioned";
// import "react-awesome-slider/dist/styles.css";
// import "react-awesome-slider/dist/captioned.css";
import withAutoplay from "react-awesome-slider/dist/autoplay";
import "react-awesome-slider/dist/custom-animations/scale-out-animation.css";
// import AwesomeSliderStyles from "react-awesome-slider/src/styled/scale-out-animation";

export default function Home() {
  // const CaptionedSlider = withCaption(AwesomeSlider);
  const AutoplaySlider = withAutoplay(AwesomeSlider);
  return (
    <Layout>
      {/* <div className="position-relative font-BohemianTypewriter">
        <img src="/entrance8.jpg" className="entrance" alt="Entrance" />

        <Typewriter
          className="text-img-centered"
          options={{
            wrapperClassName: "company-name-typewriter",
          }}
          onInit={typewriter => {
            typewriter
              .pauseFor(250)
              .typeString("Audácia Mobiliário")
              .callFunction(() => {
                console.log("String typed out!");
              })
              .pauseFor(2500)
              .callFunction(() => {
                console.log("All strings were deleted");
              })
              .start();
          }}
        />

        <div className="quoted-text font-monospace me-5">
          <div>“A beleza das coisas existe no espirito de quem as contempla“</div>
          <div className="fst-italic small">David Hume</div>
        </div>
      </div> */}
      {/* 
      <AwesomeSlider
        media={[
          {
            source: "/entrance/entance.JPG",
          },
          {
            source: "/entrance/shelve.JPG",
          },
          {
            source: "/entrance/table.JPG",
          },
        ]}
      /> */}

      {/* <AwesomeSlider>
        <div data-src="/entrance/entance.JPG">
          <p>I want to see what you got.</p>
        </div>
        <div data-src="/entrance/shelve.JPG">
          <p>The answer is -- Don't think about it.</p>
        </div>
        <div data-src="/entrance/table.JPG">
          <p>Love, connection, experience.</p>
        </div>
      </AwesomeSlider> */}

      <AutoplaySlider play={true} cancelOnInteraction={false} interval={6000} animation="scaleOutAnimation">
        <div data-src="/entrance/entance.JPG">
          <p>I want to see what you got.</p>
        </div>
        <div data-src="/entrance/shelve.JPG">
          <p>The answer is -- Don't think about it.</p>
        </div>
        <div data-src="/entrance/table.JPG">
          <p>Love, connection, experience.</p>
        </div>
      </AutoplaySlider>

      <section id="company" className="company pb-5">
        <div className="container px-4 px-md-3">
          <History />
        </div>
      </section>

      <section id="services" className="services pb-5">
        <div className="container px-4 px-md-3">
          <Services />
        </div>
      </section>

      <section id="testimonials" className="testimonials pb-5">
        <div className="container px-4 px-md-3">
          <h1 className="mt-5 mb-5 text-center">
            <Trans>TESTIMONIALS</Trans>
          </h1>
          <div className="row">
            <div className="col-md-6 col-lg-4 mb-4">
              <div className="d-flex flex-column">
                <div>
                  <p className="lead">
                    "Lorem Ipsum ist ein einfacher Demo-Text für die Print- und Schriftindustrie. Lorem Ipsum ist in der Industrie bereits
                    der Standard Demo-Text "Sed ut."
                  </p>
                </div>
                <div className="align-items-end d-flex flex-column">
                  <svg
                    className="bd-placeholder-img rounded d-block"
                    width="200"
                    height="200"
                    xmlns="http://www.w3.org/2000/svg"
                    role="img"
                    aria-label="Placeholder: 200x200"
                    preserveAspectRatio="xMidYMid slice"
                    focusable="false"
                  >
                    <title>Placeholder</title>
                    <rect width="100%" height="100%" fill="#868e96"></rect>
                    <text x="50%" y="50%" fill="#dee2e6" dy=".3em">
                      200x200
                    </text>
                  </svg>
                  <div className="d-flex">
                    <p className="fs-5">Patrick muriungi</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 mb-4">
              <div className="d-flex flex-column">
                <div>
                  <p className="lead">
                    "Lorem Ipsum ist ein einfacher Demo-Text für die Print- und Schriftindustrie. Lorem Ipsum ist in der Industrie bereits
                    der Standard Demo-Text "Sed ut."
                  </p>
                </div>
                <div className="align-items-end d-flex flex-column">
                  <svg
                    className="bd-placeholder-img rounded d-block"
                    width="200"
                    height="200"
                    xmlns="http://www.w3.org/2000/svg"
                    role="img"
                    aria-label="Placeholder: 200x200"
                    preserveAspectRatio="xMidYMid slice"
                    focusable="false"
                  >
                    <title>Placeholder</title>
                    <rect width="100%" height="100%" fill="#868e96"></rect>
                    <text x="50%" y="50%" fill="#dee2e6" dy=".3em">
                      200x200
                    </text>
                  </svg>
                  <div className="d-flex">
                    <p className="fs-5">Patrick muriungi</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-4 mb-4">
              <div className="d-flex flex-column">
                <div>
                  <p className="lead">
                    "Lorem Ipsum ist ein einfacher Demo-Text für die Print- und Schriftindustrie. Lorem Ipsum ist in der Industrie bereits
                    der Standard Demo-Text "Sed ut."
                  </p>
                </div>
                <div className="align-items-end d-flex flex-column">
                  <svg
                    className="bd-placeholder-img rounded d-block"
                    width="200"
                    height="200"
                    xmlns="http://www.w3.org/2000/svg"
                    role="img"
                    aria-label="Placeholder: 200x200"
                    preserveAspectRatio="xMidYMid slice"
                    focusable="false"
                  >
                    <title>Placeholder</title>
                    <rect width="100%" height="100%" fill="#868e96"></rect>
                    <text x="50%" y="50%" fill="#dee2e6" dy=".3em">
                      200x200
                    </text>
                  </svg>
                  <div className="d-flex">
                    <p className="fs-5">Patrick muriungi</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="followus" className="followus pb-5">
        <div className="container px-4 px-md-3">
          <h1 className="my-5 text-center">
            <Trans>Siga-nos nas redes sociais</Trans>
          </h1>
          {/* <div className="row justify-content-md-center">
            <div className="col-md-auto">
              Siga-nos a partir do
              <a className="icon" href="https://www.facebook.com/audaciamobiliario" target="_blank" rel="noreferrer">
                <img src="/facebook.svg" alt="facebook link-footer" width="24px" />
                <span>Facebook</span>
              </a>
            </div>
            <div className="col-md-auto">
              Siga-nos a partir do
              <a className="icon" href="https://www.instagram.com/audaciahomelovers" target="_blank" rel="noreferrer">
                <img src="/instagram.svg" alt="instagram link-footer" width="24px" />
                <span>Instagram</span>
              </a>
            </div>
          </div> */}
          <div className="row justify-content-md-center">
            <div className="col-md-auto text-center">
              <a className="icon btn btn-icon" href="https://www.facebook.com/audaciamobiliario" target="_blank" rel="noreferrer">
                <img src="/facebook.svg" alt="facebook link-footer" width="48px" />
              </a>
            </div>
            <div className="col-md-auto text-center">
              <a className="icon btn btn-icon" href="https://www.instagram.com/audaciahomelovers" target="_blank" rel="noreferrer">
                <img src="/instagram.svg" alt="instagram link-footer" width="48px" />
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* <div className="container px-4 px-md-3">
        <Contacts />
      </div> */}

      <section id="contactus" className="contactus pb-5">
        <div className="container px-4 px-md-3">
          <Contacts />
        </div>
      </section>
    </Layout>
  );
}

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
